import React from 'react';
import { PerspectiveCamera, OrthographicCamera } from '@react-three/drei';

/**
 * Sets the active scene camera to either Perspective or Orthographic.
 * `makeDefault` registers it with R3F so OrbitControls targets it automatically.
 *
 * @param {'perspective'|'orthographic'} cameraType
 * @param {[number,number,number]}       cameraPosition
 * @param {number}                       fov  — field of view in degrees (perspective only)
 */
function ViewerCamera({ cameraType = 'perspective', cameraPosition = [3, 2, 5], fov = 45 }) {
  if (cameraType === 'orthographic') {
    return (
      <OrthographicCamera
        makeDefault
        position={cameraPosition}
        zoom={50}
        near={0.1}
        far={1000}
      />
    );
  }

  return (
    <PerspectiveCamera
      makeDefault
      position={cameraPosition}
      fov={fov}
      near={0.1}
      far={1000}
    />
  );
}

export default ViewerCamera;
